const instaHelpDetailedRateCard = {
  key: "insta-help",
  title: "Insta Help Detailed Rate Card",
  note:
    "Indicative quick-help pricing. These tasks should stay simple and non-specialized. Skilled work should be redirected to the correct service category.",
  sections: [
    {
      title: "Short Task Slots",
      items: [
        { name: "Quick help - 30 minutes", price: "₹199" },
        { name: "Quick help - 60 minutes", price: "₹349" },
        { name: "Quick help - 2 hours", price: "₹599" },
      ],
    },
    {
      title: "Consultation",
      items: [
        { name: "Custom quick task suitability review", price: "₹149" },
      ],
    },
  ],
};

export default instaHelpDetailedRateCard;